export default __webpack_public_path__ + "static/media/ferry_logo.824112aa.png";